
import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviourSubjectService } from '../../shared/services/behaviour-subject.service';
import { environment } from '../../../environments/environment';
import { RootService } from 'src/app/shared/services/root.service';
import { StoreVariableService } from '../store-variable.service';

@Component({
  selector: 'app-advance-header',
  templateUrl: './advance-header.component.html',
  styleUrls: ['./advance-header.component.scss']
})
export class AdvanceHeaderComponent implements OnInit {
  @Input() breadcrumb: any;
  @Output() valueChange = new EventEmitter();
  environment1 = environment.s3bucket.url;
  TotalCounts=0;
  SearchValue:any;
  level2name:any;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,private route: ActivatedRoute,private router:Router,private service:BehaviourSubjectService, private storageService: RootService,private storeservice:StoreVariableService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.SearchValue=params['search']
      this.level2name=params['level2name']
    })
    this.service.SearchConsoleFilterCount.subscribe(message => {
      this.TotalCounts=message
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
  }

  valueChanged(val) {
    // setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        if (val == "search1") {
          document.getElementById("searchBtn").click();
          this.router.navigate(['advancesearch'])
        }
        // setTimeout(() => {

      if(val == "search2"){
        document.getElementById("search2btn").click();
        // this.router.navigate(['advancesearch1/vehicle-map'])
        this.router.navigate(['advancesearch/',this.SearchValue,this.breadcrumb.l1_actual_name]);
      }
      else if(val == "search3"){
        document.getElementById("search3btn").click();
        // this.router.navigate(['advancesearch1/vehicle-list'])
        this.router.navigate(['advancesearch/',this.SearchValue,this.breadcrumb.l1_actual_name,this.breadcrumb.l2_actual_name]);
      }
      else if(val == "search4"){
        if (this.router.url.includes('plp-list')) {
          document.getElementById("search4btn").click();
          // this.router.navigate(['advancesearch1/vehicle-smart'])
          this.router.navigate(['advancesearch/',this.SearchValue,this.breadcrumb.l1_actual_name,this.breadcrumb.l2_actual_name,this.level2name,this.breadcrumb?.l3_actual_name,this.storeservice.vcNumber,'smart-filter']);
        }
        else{
          document.getElementById("search4btn").click();
          // this.router.navigate(['advancesearch1/vehicle-smart'])
          this.router.navigate(['advancesearch/',this.SearchValue,this.breadcrumb.l1_actual_name,this.breadcrumb.l2_actual_name,this.level2name,this.breadcrumb?.l3_actual_name,this.storeservice.vcNumber]);
        }

      }
      this.valueChange.emit(val);
    // }, 50);
    }

    // }, 50);
  }
  backClick(){
   
      if(this.breadcrumb.l4_actual_name){
        this.valueChanged('search4');
      }
    if(this.breadcrumb?.l3_actual_name){
      this.valueChanged('search3');
    }
    else if(this.breadcrumb.l2_actual_name){
      this.valueChanged('search2');
    }
    else if(this.breadcrumb.l1_actual_name){
       if (isPlatformBrowser(this.platformId)) {
      document.getElementById("searchBtn").click();
       }
      // this.valueChanged('search1');
    }
  
  }
  GoHome()
  {
    this.router.navigate(['/home'])
  }

}
